import { IconTower } from '@sequencehq/core-components'
import { useAtomValue } from 'jotai'
import { automationsPaths } from 'Automations/router'
import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { NavLink } from 'components/NavigationV3/types'
import { getRecognisedTaskTypes } from 'Automations/watchtower/inbox/isRecognisedTaskType'
import { optimisticallyViewedTaskIdsAtom } from '../manualTasksInbox/atoms'

const UNREAD_COUNT_POLLING_INTERVAL = 5000

export const useWatchtowerNavItem = (): NavLink => {
  const unreadTasksQuery = useQuery(
    dashboardv99990101Client.getManualTasks,
    {
      status: 'PENDING',
      viewed: false,
      // Only count task types the inbox can render; the backend may create
      // tasks of types the frontend doesn't yet support, and those would
      // otherwise inflate the badge without appearing in the list.
      type: getRecognisedTaskTypes().join(','),
      limit: 1
    },
    {
      refetchInterval: UNREAD_COUNT_POLLING_INTERVAL
    }
  )

  const optimisticallyViewedTaskIds = useAtomValue(
    optimisticallyViewedTaskIdsAtom
  )

  const totalUnreadTasks = Math.max(
    0,
    (unreadTasksQuery.data?.pagination.totalResultSize ?? 0) -
      optimisticallyViewedTaskIds.size
  )

  return {
    icon: IconTower,
    label: 'Watchtower',
    href: automationsPaths.manualTasksInbox(),
    count: totalUnreadTasks,
    isLoading: false,
    'data-testid': 'watchtower-link'
  }
}
